import { CodatConnectorType, ConnectorSource } from '@hum/icm-app/src/state';

import { expandConnectUrl } from '@hum/icm-app/src/utils';
import { AvailableServiceInfo } from './base';
import { CodatConnectorTypeValue, getCodatConnectionUrl } from './codatCommon';

export const codatQuickbooksSandboxConnector: AvailableServiceInfo = {
  label: 'QuickBooks',
  description: 'Sandbox',
  type: CodatConnectorType.QuickbooksSandbox,
  icon: require('./quickbooks.svg'),
  icon2: require(`@hum/figma/components/logo/quickbooks@1.svg`),
  source: ConnectorSource.Codat,
  connect: async (_params, options) => {
    if ('companyId' in options) {
      const connectionUrl = await getCodatConnectionUrl({
        companyId: options.companyId,
        type: CodatConnectorTypeValue.QuickBooksSandbox,
      });

      if (connectionUrl.data?.connectUrl) {
        window.open(expandConnectUrl(connectionUrl.data.connectUrl));
      }

      return connectionUrl;
    }
    return {};
  },
};
